export default ms => new Promise(resolve => setTimeout(resolve, window._env_.REACT_APP_ENVIRONMENT === 'development' ? ms : 0))